export const firebaseConfig = {
  apiKey: 'AIzaSyBJ1MNdqlCOmPXK3taPtmuEJbsrmtiUDxU',
  authDomain: 'goodbike-cd338.firebaseapp.com',
  projectId: 'goodbike-cd338',
  storageBucket: 'goodbike-cd338.appspot.com',
  messagingSenderId: '177294326394',
  appId: '1:177294326394:web:00671a5c16846c33e499c3',
};

export const proxy = 'https://proxycall-gj5n6pnsva-uc.a.run.app?url=';
export const baseUrl = 'http://200.234.207.52:8000/stations';

export const firestoreId = '(default)';
export const secrets = { sk: '' };

export const configMap = {
  zoom: 16,
  center: {
    latitude: -23.774537164610383,
    longitude: -46.597566673985,
  },
};
